'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface OmniBoxContextType {
  isExpanded: boolean;
  expand: () => void;
  collapse: () => void;
  toggle: () => void;
}

const OmniBoxContext = createContext<OmniBoxContextType | undefined>(undefined);

export const useOmniBox = (): OmniBoxContextType => {
  const context = useContext(OmniBoxContext);
  if (context === undefined) {
    throw new Error('useOmniBox must be used within an OmniBoxProvider');
  }
  return context;
};

interface OmniBoxProviderProps {
  children: ReactNode;
}

export const OmniBoxProvider: React.FC<OmniBoxProviderProps> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const expand = () => setIsExpanded(true);
  const collapse = () => setIsExpanded(false);
  const toggle = () => setIsExpanded((prev) => !prev);

  const value = {
    isExpanded,
    expand,
    collapse,
    toggle,
  };

  return <OmniBoxContext.Provider value={value}>{children}</OmniBoxContext.Provider>;
};
